export default __webpack_public_path__ + "static/media/home_01_inactive.ac6e017e.png";